import React from "react";
import Navbar from "../navbar/Navbar";
import UserCard, { StudiesCard, ModelsCard, DatasetsCard, ProjectsCard, ViewersCard, ToolsCard } from './cards';
import { ToastContainer } from "react-toastify";
import './dashboard.css';

const Dashboard = () => {
    return (
        <div className="dashboard-page">
            {/* Starfield Background */}
            <div className="starfield-background"></div>

            {/* Header Navigation */}
            <Navbar />

            <ToastContainer autoClose={3000} />

            {/* Main Content */}
            <div className="container py-4">
                {/* User Profile Card */}
                <div className="row justify-content-center mb-4">
                    <div className="col-lg-8 col-xl-6">
                        <UserCard />
                    </div>
                </div>

                {/* Dashboard Sections — order matches the My Home dropdown:
                    Projects, Studies, Datasets, Viewers, Models, Tools. */}
                <div className="row">
                    <div className="col-12">
                        <ProjectsCard />
                        <StudiesCard />
                        <DatasetsCard />
                        <ViewersCard />
                        <ModelsCard />
                        <ToolsCard />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
